import React from 'react'

const Audience = () => {
  return (
    <>
      <section>
        <h1>Audience</h1>
      </section> 
    </>
  )
}

export default Audience
